import authType from '@/config/authType';
const formItems = [
  { label: '模版组名称', model: 'title', type: 'input', span: 6 },
  {
    type: 'button',
    buttonArr: [
      { message: '查询', type: 'primary', fun: 'searchTableInfo' },
      { message: '重置', type: 'warning', fun: 'resetTableInfo' }
    ],
    span: 18
  }
];
const getColumnsMap = (methods) => {
  return {
    name: {
      title: '审批组名称',
      key: 'name',
      minWidth: 200,
      ellipsis: true,
      tooltip: true
    },
    note: {
      title: '审批组描述',
      key: 'note',
      minWidth: 200,
      ellipsis: true,
      tooltip: true
    },
    creator: {
      title: '创建人',
      key: 'creator',
      minWidth: 100
    },
    addTime: {
      title: '创建时间',
      key: 'addTime',
      minWidth: 300
    },
    operator: {
      title: '更新人',
      key: 'operator',
      minWidth: 100
    },
    updateTime: {
      title: '更新时间',
      key: 'updateTime',
      minWidth: 150
    },
    sort: {
      title: '排序权重',
      key: 'sort',
      minWidth: 50
    },
    status: {
      title: '状态',
      key: 'status',
      width: 100,
      align: 'center',
      render: (h, params) => {
        const { row } = params;
        return h('Tag', row.status == 0 ? { props: { color: 'volcano' } } : { props: { color: 'green' } }, row.status == 0 ? '停用' : '启用');
      }
    },
    action: {
      title: '操作',
      align: 'left',
      key: 'action',
      minWidth: 130,
      fixed: 'right',
      render: (h, { row }) => {
        const buttonArr = [];
        const { status, id } = row;
        // status = 0 停用， 1 启用 状态， 所以文字展示要相反
        const statusText = status ? '停用' : '启用';
        const statusType = status ? 'error' : 'warning';
        if (id != 1) {
          buttonArr.push(
            h('CustomButton', {
              props: { type: 'success', size: 'small', permissionCode: authType.tplGroupManage.edit },
              style: { margin: '4px' },
              on: {
                click: () => {
                  methods.edit({ isEdit: true, id });
                }
              }
            }, '编辑')
          );
          buttonArr.push(
            h('CustomButton', {
              props: { type: statusType, size: 'small', permissionCode: authType.tplGroupManage.changeStatus },
              style: { margin: '4px' },
              on: {
                click: () => {
                  methods.toggleStatus({ id, status });
                }
              }
            }, statusText)
          );
        }
        return h('div', { style: { 'text-align': 'left' } }, buttonArr);
      }
    }
  };
};
const getColumns = (methods, noShowArr) => {
  const columnsMap = getColumnsMap(methods);
  const keyArr = Object.keys(columnsMap);
  const columns = [];
  keyArr.forEach(key => {
    if (!noShowArr || !noShowArr.includes(key)) {
      columns.push(columnsMap[key]);
    }
  });
  return columns;
};
export { formItems, getColumns };
